"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 13, height: 13, viewBox: "0 0 13 13" }, props),
        React.createElement(react_native_svg_1.Path, Object.assign({ fillRule: "evenodd", clipRule: "evenodd", d: "M6.68 1.426a.203.203 0 00-.36 0L1.38 10.67a.203.203 0 00.179.299h9.882a.203.203 0 00.18-.3L6.678 1.427zM5.245.85C5.782-.15 7.218-.15 7.754.851l4.941 9.245a1.422 1.422 0 01-1.254 2.092H1.56a1.422 1.422 0 01-1.254-2.092L5.245.851zm2.066 8.087a.812.812 0 11-1.625 0 .812.812 0 011.625 0zM7.11 4.673a.61.61 0 00-1.218 0v2.031a.61.61 0 001.218 0V4.673z", fill: "#436EAC" }, props))));
}
exports.default = SvgComponent;
